module.exports = __webpack_public_path__ + "static/media/instagram.9f41e00c.svg";